import detailAccount from './account.vue'
import detailPhoto from './photo.vue'
import detailBase from './base.vue'

export { detailAccount, detailPhoto, detailBase }
